export default __webpack_public_path__ + "assets/padrao-component.ca78f50d.svg";